import AdxSortTable from 'components/reusable/table/AdxSortTable'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Icon from '@mui/material/Icon'
import CardMedia from '@mui/material/CardMedia'

import { useLocation, useNavigate } from 'react-router-dom'
import StepperAvatar from 'components/reusable/AdxProgressStepper/StepperAvatar'
import ClaimProgressTooltip from './ClaimProgressTooltip'
import defaultImage from 'assets/images/default_avatar.png'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'

const ClaimUpcomingTab = ({
  upcomingData,
  error,
  pagination,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const upcomingRequestColumn = [
    {
      Header: 'Request',
      accessor: 'title',
      Cell: (props) => {
        const data = props.row.original
        return (
          <Box
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
            columnGap={3}
          >
            <Box display="flex" alignItems="center" columnGap={2}>
              <Box
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                width={50}
                height={50}
                bgcolor="alternate.light"
                borderRadius={'50%'}
              >
                <Icon sx={{ fontSize: 25, color: 'alternate.main' }}>article</Icon>
              </Box>
              <Box>
                <Typography
                  width={{
                    xs: 'calc(100vw - 400px)',
                    lg: 'calc(100vw - 1200px)',
                  }}
                  minWidth={{ xs: 1, lg: '200px' }}
                  noWrap
                  variant="body1"
                  color="dark-text.main "
                  textTransform="capitalize"
                >
                  {data.title}
                </Typography>
                <Box display={'flex'} alignItems={'center'} columnGap={1.5}>
                  <Typography
                    noWrap
                    component="span"
                    variant="body2"
                    color="light-gray-text.main"
                    textTransform="capitalize"
                  >
                    {data.claim_report_type}
                  </Typography>

                  <Icon sx={{ fontSize: 7, color: 'light-gray-text.main' }}>circle_rounded</Icon>

                  <Typography
                    noWrap
                    component="span"
                    variant="body2"
                    color="light-gray-text.main"
                    textTransform="capitalize"
                  >
                    {data.start_date} - {data.end_date}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        )
      },
    },
    {
      Header: 'Amount',
      accessor: 'amount_total',
      Cell: (props) => {
        const data = props.row.original
        return (
          <Box display={'flex'} flexDirection="column" justifyContent="center" rowGap={0.5}>
            <Typography variant="body1" color="dark-text.main" align="left" noWrap>
              {`RM ${parseFloat(data.amount_total).toFixed(2)}`}
            </Typography>
          </Box>
        )
      },
    },
    {
      Header: 'Requester',
      accessor: 'staff_name',
      Cell: (props) => {
        const data = props.row.original
        return (
          <Box display={'flex'} alignItems="center" columnGap={1}>
            <CardMedia
              component="img"
              sx={{
                height: 52,
                width: 52,
                bgcolor: 'gray-background.main',
                objectFit: 'cover',
                borderRadius: '50%',
                border: '3px solid',
                borderColor: 'white.main',
              }}
              alt={data.staff_name}
              src={data.staff_img || defaultImage}
            />

            <Typography variant="body1" color="dark-text.main" align="left" maxWidth={150} noWrap>
              {data.staff_name}
            </Typography>
          </Box>
        )
      },
    },
    {
      Header: 'Progress',
      accessor: 'currentProgress.status',
      Cell: (props) => {
        const data = props.row.original
        return (
          <ClaimProgressTooltip
            data={{
              members: data?.report_progress?.members,
              status: data?.report_status?.name,
            }}
          >
            <Box
              height="52px"
              width="52px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              position="relative"
            >
              <StepperAvatar
                name={data?.report_progress?.members}
                imgUrl={data?.report_progress?.profilePics}
                active
                sxAvatar={{ borderColor: 'white.main' }}
                disableToolTip
              />
            </Box>
          </ClaimProgressTooltip>
        )
      },
    },
  ]

  const navigate = useNavigate()
  const backgroundLocation = useLocation()
  const hasUpcomingClaims = (upcomingData || []).length > 0

  return hasUpcomingClaims ? (
    <AdxSortTable
      height="calc(100vh - 235px)"
      divClick
      onClick={(e) =>
        navigate(`/app/approval-center/claim/request/${e.id}`, {
          state: {
            backgroundLocation,
            data: e,
          },
        })
      }
      column={upcomingRequestColumn}
      data={upcomingData || []}
      pagination={Boolean(pagination)}
      count={pagination?.total}
      page={page}
      onPageChange={onPageChange}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={onRowsPerPageChange}
      sx={{
        marginRight: '10px',
        boxShadow: null,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
      }}
    />
  ) : (
    <AdxEmptyStateV2
      title={
        error?.status === 403
          ? 'You are not authorized to access this feature. Please contact your admin for access.'
          : 'No pending claim request'
      }
    />
  )
}

export default ClaimUpcomingTab
